// extracted by mini-css-extract-plugin
export default {"main":"main--PdydM","offline":"offline--kWpYq"};